import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createArea = ( {data} : {data: IPostNewArea | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/Areas/InsertArea`, data);
};

type QueryFnType = typeof createArea;

type UseCreateAreaOptions = {
  data: IPostNewArea | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateArea = ({ config }: UseCreateAreaOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία της Περιοχής.`, 500);
            console.error('Couldnt create new area', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllAreas"])
            addNotification("Δημιουργήθηκε Νέα Περιοχή.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createArea,
    })
}